import { createElement } from 'react';
import './index.scss';
import { convertChildren } from '../../../src/utils/children-node-handle';
const Profile = ({ dataList, onClick, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    console.log('dataList', dataList);
    return (createElement("div", { className: "profile", ..._otherProps, onClick: onClick },
        convertChildren(children, 'image', {
            src: `https://51ymb.com/source/api/upload/${dataList?.headPath}`,
            className: 'profile__image',
        }),
        createElement("div", { className: "profile__info" },
            convertChildren(children, 'userName', {
                children: [dataList?.userName],
                className: 'profile__name',
            }),
            convertChildren(children, 'phone', {
                children: [dataList?.phone],
                className: 'profile__phone',
            }),
            convertChildren(children, 'button', {
                children: ['Edit'],
                onClick,
                className: 'profile__button',
            }))));
};
Profile.displayName = 'Profile';
export default Profile;
